import React from 'react';
import * as Sentry from '@sentry/react';

interface UserFeedbackProps {
  className?: string;
}

export const UserFeedback: React.FC<UserFeedbackProps> = ({ className }) => {
  const handleFeedbackClick = () => {
    const eventId = Sentry.captureMessage('User Feedback');
    Sentry.showReportDialog({
      eventId,
      user: {
        email: '', // Will be filled by the user in the form
        name: ''   // Will be filled by the user in the form
      },
      title: 'Share Your Feedback',
      subtitle: 'Help us improve the Care Portal',
      subtitle2: 'Your feedback is valuable to us',
      labelName: 'Name',
      labelEmail: 'Email',
      labelComments: 'What would you like to share?',
      labelClose: 'Close',
      labelSubmit: 'Send Feedback',
      errorGeneric: 'An error occurred while submitting your feedback. Please try again.',
      errorFormEntry: 'Some fields were invalid. Please correct the errors and try again.',
      successMessage: 'Thank you for your feedback!'
    });
  };

  return (
    <button
      type="button"
      onClick={handleFeedbackClick}
      className={`-m-2.5 p-2.5 text-gray-400 hover:text-gray-500 ${className || ''}`}
      aria-label="Provide feedback"
    >
      <span className="sr-only">Provide feedback</span>
      <FeedbackIcon className="h-6 w-6" aria-hidden="true" />
    </button>
  );
};

function FeedbackIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" {...props}>
  { }
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 12.75c1.148 0 2.278.08 3.383.237 1.037.146 1.866.966 1.866 2.013 0 3.728-2.35 6.75-5.25 6.75S6.75 18.728 6.75 15c0-1.046.83-1.867 1.866-2.013A24.204 24.204 0 0112 12.75zm0 0c2.883 0 5.647.508 8.207 1.44a23.91 23.91 0 01-1.152 6.06M12 12.75c-2.883 0-5.647.508-8.208 1.44.125 2.104.52 4.136 1.153 6.06M12 12.75a2.25 2.25 0 002.248-2.354M12 12.75a2.25 2.25 0 01-2.248-2.354M12 8.25c.995 0 1.971-.08 2.922-.236.403-.066.74-.358.795-.762a3.778 3.778 0 00-.399-2.25M12 8.25c-.995 0-1.97-.08-2.922-.236-.402-.066-.74-.358-.795-.762a3.734 3.734 0 01.4-2.253M12 8.25a2.25 2.25 0 00-2.248 2.146M12 8.25a2.25 2.25 0 012.248 2.146M8.683 5a6.032 6.032 0 01-1.155-1.002c.07-.63.27-1.222.574-1.747m.581 2.749A3.75 3.75 0 0115.318 5m0 0c.427-.283.815-.62 1.155-.999a4.471 4.471 0 00-.575-1.752M4.921 6a24.048 24.048 0 00-.392 3.314c1.668.546 3.416.914 5.223 1.082M19.08 6c.205 1.08.337 2.187.392 3.314a23.882 23.882 0 01-5.223 1.082" />
    </svg>
  );
}
